import axios from 'axios'
import {
  GET_DAG_ERRORS,
  RESET_DAG_STATE,
  SET_DAG_LOADING,
  GET_DAG_FILTERS,
  GET_DAG_FILTER,
  GET_DAG_FILTER_VALUE,
  GET_DAG_FILTER_VALUE_DYNAMIC_APPS,
  GET_DAG_FILTER_VALUE_USERS,
  GET_DAG_MASTER_APP,
  GET_DAG_DYNAMIC_APP,
  GET_DYNAMIC_APPS,
  GET_MASTER_APPS,
  GET_MASTER_APPS_FAILED,
  SET_DAG_FILTER,
  SET_DAG_FILTER_VALUE,
  SET_DAG_FILTER_VALUE_USER,
  SET_DAG_MASTER_APP,
} from './types'
import { ToastsStore } from 'react-toasts'

export const getMasterApps = () => dispatch => {
  dispatch(setDagLoading)

  axios
    .get('/api/qlik/master-app/read')
    .then(res => {
      return dispatch({
        type: GET_MASTER_APPS,
        payload: res.data,
      })
    })
    .catch(err => {
      dispatch({
        type: GET_MASTER_APPS_FAILED,
        payload: err.response.data,
      })
    })
}
export const setMasterApp = (masterApp, history) => dispatch => {
  dispatch(setDagLoading())
  axios
    .post('/api/qlik/master-app/create', masterApp)
    .then(res => {
      history.push('/settings/dag/master-apps') //Redirect to master apps on complete
      return dispatch({
        type: SET_DAG_MASTER_APP,
        payload: res.data,
      })
    })
    .catch(err => {
      dispatch({
        type: GET_DAG_ERRORS,
        payload: err.response.data,
      })
    })
}
export const updateMasterApp = (masterApp, history) => dispatch => {
  dispatch(setDagLoading())
  axios
    .post(`/api/qlik/master-app/update/${masterApp.id}`, masterApp)
    .then(res => {
      // history.push('/settings/dag/master-apps'); //Redirect to master apps on complete
      ToastsStore.success('Master app updated successfully')
      return dispatch({
        type: SET_DAG_MASTER_APP,
        payload: res.data,
      })
    })
    .catch(err => {
      dispatch({
        type: GET_DAG_ERRORS,
        payload: err.response.data,
      })
    })
}
export const getMasterApp = masterApp => dispatch => {
  dispatch(setDagLoading)

  axios
    .get(`/api/qlik/master-app/read/${masterApp}`)
    .then(res => {
      return dispatch({
        type: GET_DAG_MASTER_APP,
        payload: res.data,
      })
    })
    .catch(err => {
      dispatch({
        type: GET_MASTER_APPS_FAILED,
        payload: err.response.data,
      })
    })
}
export const deleteMasterApp = masterApp => dispatch => {
  dispatch(setDagLoading)
  axios
    .delete(`/api/qlik/master-app/${masterApp}`)
    .then(res => {
      dispatch({
        type: GET_MASTER_APPS,
        payload: res.data,
      })
    })
    .catch(err => {
      dispatch({
        type: GET_DAG_ERRORS,
        payload: err.response.data,
      })
    })
}
export const deleteAllDynamicApps = (dynamicApps, filterValue) => async dispatch => {
  dispatch(setDagLoading())

  const dynamicAppsCount = dynamicApps.length
  let counter = 0
  const errors = []
  for (var i = 0; i < dynamicAppsCount; ) {
    try {
      let res = await axios.delete(`/api/filters/delete/dynamic-app/${dynamicApps[i]._id}`)
      if (res.data) {
        i++
      }
    } catch (err) {
      if (err) {
        errors.push(err)
        i++
      }
    }
    counter++
  }

  if (dynamicAppsCount === counter && errors.length === 0) {
    ToastsStore.success('Dynamic applications deleted successfully')
    if (filterValue) {
      dispatch(getFilterValueApps(filterValue))
    } else {
      dispatch(getDynamicApps())
    }
  } else if (dynamicAppsCount === counter && errors.length > 0) {
    ToastsStore.success('Dynamic applications deleted with errors')
    if (filterValue) {
      dispatch(getFilterValueApps(filterValue))
    } else {
      dispatch(getDynamicApps())
    }
  }
}

export const getDynamicApps = () => dispatch => {
  dispatch(setDagLoading)

  axios
    .get('/api/filters/read/dynamic-apps')
    .then(res => {
      return dispatch({
        type: GET_DYNAMIC_APPS,
        payload: res.data,
      })
    })
    .catch(err => {
      dispatch({
        type: GET_DAG_ERRORS,
        payload: err.response.data,
      })
    })
}
export const getDynamicApp = id => dispatch => {
  dispatch(setDagLoading)
  axios
    .get(`/api/filters/read/dynamic-apps/${id}`)
    .then(res => {
      return dispatch({
        type: GET_DAG_DYNAMIC_APP,
        payload: res.data,
      })
    })
    .catch(err => {
      if (err.response) {
        dispatch({
          type: GET_DAG_ERRORS,
          payload: err.response.data,
        })
      }
    })
}

export const getFilters = () => dispatch => {
  axios
    .get('/api/filters/read')
    .then(res => {
      return dispatch({
        type: GET_DAG_FILTERS,
        payload: res.data,
      })
    })
    .catch(err => {
      dispatch({
        type: GET_DAG_ERRORS,
        payload: err.response.data,
      })
    })
}
export const getFilter = filter => dispatch => {
  axios
    .get(`/api/filters/read/${filter}`)
    .then(res => {
      return dispatch({
        type: GET_DAG_FILTER,
        payload: res.data,
      })
    })
    .catch(err => {
      dispatch({
        type: GET_DAG_ERRORS,
        payload: err.response.data,
      })
    })
}
export const setFilter = (filter, history) => dispatch => {
  dispatch(setDagLoading())
  axios
    .post('/api/filters/create', filter)
    .then(res => {
      history.push('/settings/dag/filters')
      ToastsStore.success('New filter created successfully')
      dispatch({
        type: SET_DAG_FILTER,
        payload: res.data,
      })
    })
    .catch(err => {
      dispatch({
        type: GET_DAG_ERRORS,
        payload: err.response.data,
      })
    })
}
export const updateFilter = filter => dispatch => {
  dispatch(setDagLoading())
  axios
    .post(`/api/filters/update/${filter.id}`, filter)
    .then(res => {
      ToastsStore.success('Filter updated successfully')

      return dispatch({
        type: SET_DAG_FILTER,
        payload: res.data,
      })
    })
    .catch(err => {
      dispatch({
        type: GET_DAG_ERRORS,
        payload: err.response.data,
      })
    })
}
export const deleteFilter = filter => dispatch => {
  dispatch(setDagLoading())
  axios
    .delete(`/api/filters/delete/${filter}`)
    .then(() => {
       dispatch(getFilters())
    })
    .catch(err => {
      dispatch({
        type: GET_DAG_ERRORS,
        payload: err.response.data,
      })
    })
}
export const getFilterValue = filter => dispatch => {
  axios
    .get(`/api/filters/read/value/${filter}`)
    .then(res => {
      return dispatch({
        type: GET_DAG_FILTER_VALUE,
        payload: res.data,
      })
    })
    .catch(err => {
      dispatch({
        type: GET_DAG_ERRORS,
        payload: err.response.data,
      })
    })
}
export const setFilterValue = (filterValue, history) => dispatch => {
  dispatch(setDagLoading())
  axios
    .post(`/api/filters/create/value`, filterValue)
    .then(res => {
      ToastsStore.success('Filter value created successfully')

      dispatch({
        type: SET_DAG_FILTER_VALUE,
        payload: res.data,
      })
      history.push(`/settings/dag/filters/view/${filterValue.filter}`)
    })
    .catch(err => {
      dispatch({
        type: GET_DAG_ERRORS,
        payload: err.response.data,
      })
    })
}
export const updateFilterValue = filterValue => dispatch => {
  dispatch(setDagLoading())
  axios
    .post(`/api/filters/update/value/${filterValue.id}`, filterValue)
    .then(res => {
      ToastsStore.success('Filter value updated successfully')
      dispatch({
        type: SET_DAG_FILTER_VALUE,
        payload: res.data,
      })
    })
    .catch(err => {
      dispatch({
        type: GET_DAG_ERRORS,
        payload: err.response.data,
      })
    })
}
export const deleteFilterValue = (filterValue, filter) => dispatch => {
  dispatch(setDagLoading())
  axios
    .delete(`/api/filters/delete/value/${filterValue}`)
    .then(() => {
      dispatch(getFilter(filter))
    })
    .catch(err => {
      dispatch({
        type: GET_DAG_ERRORS,
        payload: err.response.data,
      })
    })
}
export const getFilterValueUsers = filterValue => dispatch => {
  dispatch(setDagLoading())
  axios
    .get(`/api/filters/read/value/${filterValue}/users`)
    .then(res => {
      return dispatch({
        type: GET_DAG_FILTER_VALUE_USERS,
        payload: res.data,
      })
    })
    .catch(err => {
      dispatch({
        type: GET_DAG_ERRORS,
        payload: err.response.data,
      })
    })
}
export const setFilterValueUser = filterValueUser => dispatch => {
  dispatch(setDagLoading())
  axios
    .post('/api/filters/create/user', filterValueUser)
    .then(res => {
      dispatch({
        type: SET_DAG_FILTER_VALUE_USER,
        payload: res.data,
      })
    })
    .catch(err => {
      if (err.response) {
        if (err.response.data.flash) {
          ToastsStore.error(err.response.data.flash)
        }

        dispatch({
          type: GET_DAG_ERRORS,
          payload: err.response.data,
        })
      }
    })
}
export const deleteFilterValueUser = (user, filterValue) => dispatch => {
  dispatch(setDagLoading())
  axios
    .delete(`/api/filters/delete/value/user/${user}/${filterValue}`)
    .then(res => {
        dispatch(getFilterValueUsers(filterValue));
    })
    .catch(err => {
      dispatch({
        type: GET_DAG_ERRORS,
        payload: err.response.data,
      })
    })
}
export const getFilterValueApps = filterValue => dispatch => {
  axios
    .get(`/api/filters/read/value/${filterValue}/apps`)
    .then(res => {
      return dispatch({
        type: GET_DAG_FILTER_VALUE_DYNAMIC_APPS,
        payload: res.data,
      })
    })
    .catch(err => {
      dispatch({
        type: GET_DAG_ERRORS,
        payload: err.response.data,
      })
    })
}
export const generateDynamicApps = () => dispatch => {
  dispatch(setDagLoading())

  axios
    .get('/api/dag/sync')
    .then(res => {
      ToastsStore.success('Automatic Dynamic Application Generation Complete')

      dispatch({
        type: GET_DYNAMIC_APPS,
        payload: res.data,
      })
      // window.location.reload();
    })
    .catch(err => {
      ToastsStore.error('Error Synchronising dynamic applications, please re-sync dynamic applications')

      dispatch({
        type: GET_DAG_ERRORS,
        payload: err.response.data,
      })
    })
}
export const deleteDynamicApp = (dynamicApp, filterValue) => dispatch => {
  dispatch(setDagLoading())
  axios
    .delete(`/api/filters/delete/dynamic-app/${dynamicApp}`)
    .then(() => {
      ToastsStore.success('Dynamic application deleted successfully')
      if (filterValue) {
        dispatch(getFilterValueApps(filterValue))
      } else {
        dispatch(getDynamicApps())
      }
    })
    .catch(err => {
      dispatch({
        type: GET_DAG_ERRORS,
        payload: err.response.data,
      })
    })
}

export const resetDagState = () => dispatch => {
  dispatch({ type: RESET_DAG_STATE })
}

export const setDagLoading = () => {
  return {
    type: SET_DAG_LOADING,
  }
}
